import { createIntl, createIntlCache } from 'react-intl';

const cache = createIntlCache();

const getUserLocale = () => {
  const user = localStorage.getItem('userData');
  return JSON.parse(user)?.locale;
};

const getMessages = (locale) => {
  const persistAppData = localStorage.getItem('persist:appData');
  if (!persistAppData) return {};

  const parsed = JSON.parse(persistAppData);
  const texts = JSON.parse(parsed.texts || '{}');

  return texts.entities?.[locale];
};

const locale = getUserLocale();

const intl = createIntl(
  {
    locale: locale,
    messages: getMessages(locale),
  },
  cache
);

export const formatMessage = (id) => {
  return intl.formatMessage({ id });
};
